import React from 'react';
import { formatNumber } from "../../common/util/numberFormatter";
import { Carousel } from 'react-responsive-carousel';
import Popover from "../../common/components/popover/popover.js";
import { getFlightSuffix, convertToTonne } from "../../common/util/unitConverter";

const Impact = ({ fetchedImpact}) => {
    const passengerDistance = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.flightsImpact?.passengerDistance?.value))
    const passengerDistanceUnit = fetchedImpact && !fetchedImpact.error && getFlightSuffix(fetchedImpact.flightsImpact?.passengerDistance?.unit.toLowerCase());
    const numberOfPassengers = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributions?.value);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase()

    const getKilometersFromCo2Amount = (impact) => {
        if (!impact?.value) return 0;

        const tonnesOfCo2 = convertToTonne(impact.value, impact.unit);
        const kilometers = tonnesOfCo2 / 0.000156; //small - petrol multiplier
        return kilometers.toFixed(0);
    };

    const kmsDriven = fetchedImpact && getKilometersFromCo2Amount(fetchedImpact.carbonOffsetImpact);

    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);

    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${treeGrowthYears} trees have in one year.`;

    return (
        <div id="content" className="py-6">
            <div className="container text-center">
                <div className="mb-3 center">
                    <h3 className="font-bold">Start your Climate Friendly journey with us</h3>
                    <h5>Whether it’s the environmental impact of your driving, or other areas of your life - we’ve got you covered. By partnering with CarbonClick, we’re helping you effortlessly reduce it by connecting with gold standard projects that make a real traceable difference focussing on regenerating or reforesting New Zealand native forests and impactful clean energy projects internationally.
<br /><br />
You can offset your driving emissions directly <a className="font-bold color-primary" href="#DrivingCalculator">here</a> or use the AA Smartfuel app with CarbonClick as your reward to convert your discounts into carbon credits and help save the planet.</h5>
                </div>
                <div className="py-6 mobile-hide">

                    <div className="center shadow aa-border py-6 px-3 mb-4" >
                        <h1 className="title">{`${kmsDriven ? Math.round(kmsDriven).toLocaleString() : ''} km`}</h1>
                        <h5 className="font-bold" >Made Climate Friendly</h5>
                    </div>

                    <div className="center">
                        <div className="row text-left">

                            <div className="col-4 d-grid">
                                <div className="center w-100 shadow aa-border">
                                    <div className="img-cover h-120px impact-community w-100">

                                    </div>
                                    <div className="px-2 py-4 font-bold">
                                        <h2>{numberOfPassengers}</h2>
                                        <p>Climate Friendly Travellers</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-4 d-grid">
                                <div className="center w-100 shadow aa-border">
                                    <div className="img-cover h-120px impact-CO2 w-100">

                                    </div>
                                    <div className="px-2 py-4 font-bold">
                                        <h2>{carbonOffsetImpact}</h2>
                                        <p>{carbonOffsetImpactUnit} of CO2 Offset</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-4 d-grid">
                                <div className="center w-100 shadow aa-border">
                                    <div className="img-cover h-120px impact-trees w-100">

                                    </div>
                                    <div className="px-2 py-4 font-bold">
                                        <h2>{treeGrowthYears}</h2>
                                        <p><span className="mr-2">Tree Growth Years</span>
                                            <Popover content={treeMetric} >
                                                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                    <path d="M0 0h24v24H0z" fill="none" />
                                                    <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                </svg>
                                            </Popover>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mobile-show bg-primary py-3 mt-4 text-center">
                <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                    <div key="1" >
                        <div className="mb-3">
                            <div className="center w-100 px-3">
                                <div className="img-cover h-240px impact-flight w-100">

                                </div>
                                <div className="py-4 font-bold color-white">
                                    <h2>{passengerDistance}</h2>
                                    <p>Carbon Neutral {passengerDistanceUnit}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div key="2" >
                        <div className="mb-3">
                            <div className="center w-100 px-3">
                                <div className="img-cover h-240px impact-community w-100">

                                </div>
                                <div className="py-4 font-bold color-white">
                                    <h2>{numberOfPassengers}</h2>
                                    <p>Climate Friendly Travellers</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div key="3">
                        <div className="mb-3">
                            <div className="center w-100 px-3">
                                <div className="img-cover h-240px impact-CO2 w-100">

                                </div>
                                <div className="py-4 font-bold color-white">
                                    <h2>{carbonOffsetImpact}</h2>
                                    <p>{carbonOffsetImpactUnit} of CO2 Offset</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div key="4">
                        <div className="mb-3">
                            <div className="center w-100 px-3">
                                <div className="img-cover h-240px impact-trees w-100">
                                </div>
                                <div className="py-4 font-bold color-white">
                                    <h2>{treeGrowthYears}</h2>
                                    <p><span className="mr-2">Tree Growth Years</span>
                                        <Popover content={treeMetric} >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                            </svg>
                                        </Popover>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </div>
    );
};

export default Impact;